// **Reducer types ** //
//auth
export const SET_AUTHED_USER = "SET_AUTHED_USER";

//user
export const RECEIVE_USERS = "RECEIVE_USERS";
export const ADD_VOTE_TO_USER = "ADD_VOTE_TO_USER";
export const ADD_QUESTION_TO_USER = "ADD_QUESTION_TO_USER";

//questions
export const RECEIVE_QUESTIONS = "RECEIVE_QUESTIONS";
export const ADD_VOTE_TO_QUESTIONS = "ADD_VOTE_TO_QUESTIONS";
export const ADD_QUESTION_TO_QUESTIONS = "ADD_QUESTION_TO_QUESTIONS";
